import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Spinner from '../components/Loading&Spinners/Spinner';
import FullScreenGames from '../components/GamesComponets/FullScreenGames';
import ImageSlider from '../components/GamesComponets/ImageSlider';

const MerakiHomeBody = () => {

	const [loading, setLoading] = useState(true);

	useEffect(() => {
	  // Simulate loading delay with setTimeout
	  const timer = setTimeout(() => {
		setLoading(false); // Set loading to false after a delay
	  }, 100); // Adjust the delay as needed
  
	  // Clean up the timer when the component unmounts
	  return () => clearTimeout(timer);
	}, []); 

	const navigate = useNavigate();
	const location = useLocation();
	const [isLoading, setIsLoading] = useState(true);
  
	const actionGames=[
        { thumbnail:'sniper-3d.png',url:'sniper-3d-mod_4.35.13-an1.com.apk'},
        { thumbnail:'Tapventures.jpg',url:'Tapventures-%28MOD%29_6.7-Android-1.com.apk'},
        { thumbnail:'war-machines.png',url:'war-machines_8.33.1-an1.com.apk'},
        { thumbnail:'zombie-gunship-survival.jpg',url:'zombie-gunship-survival-mod_1.6.98-an1.com.apk'},
        { thumbnail:'dead-target-zombie.jpg',url:'dead-target-mod_4.130.0-an1.com.apk'},
    ]

	useEffect(() => {
        localStorage.setItem('jwt_j','meraki')
        // localStorage.setItem('no-msisdn','923015489456')
		const params = new URLSearchParams(location.search);
    const msisdn = params.get('msisdn');

    // Set the extracted msisdn to local storage
    if (msisdn) {
      localStorage.setItem('no-msisdn', msisdn);
    } else {
      // If msisdn is not present in the URL, set a default value
      localStorage.setItem('no-msisdn', '');
    }
	  const fetchData = async () => {
		try {
		  // Fetch any initial data you need here
		  // ...
  
		  // Simulate some delay for demonstration purposes
		  await new Promise(resolve => setTimeout(resolve, 500));
  
		  // Once data is fetched and any initial setup is done, set isLoading to false
		  setIsLoading(false);
		} catch (error) {
		  console.error('Error fetching data:', error);
		  setIsLoading(false);
		}
	  };
  
	  fetchData();
	}, []);


	const handleClick = (gamesThumbnail, gamesUrl) => {
		localStorage.setItem('gameThumbnail', gamesThumbnail);
		localStorage.setItem('gameUrl', gamesUrl);
		navigate('../game-component1');
	}
	localStorage.removeItem('gameUrl');
	localStorage.removeItem('gameThumbnail');

	const games = [
		{ thumbnail: 'Cartoon_Candy.webp', url: '066.Cartoon%20Candy/' },
		{ thumbnail: 'Road-Racer.webp', url: '106.Road%20Racer/' },
		{ thumbnail: 'Traffic-Racer.webp', url: '120.Traffic%20Racer/' },
		{ thumbnail: 'Lollipops-Match-3.webp', url: '080.Lollipops%20Match%203/' },
		{ thumbnail: 'swat-vs-zombies.webp', url: 'swat_vs_zombies/' },
	]
	// const [gameOfTheDay, setGameOfTheDay] = useState(games[1]);
	// var gameOfTheDay = games[1];

	const [gameOfTheDay, setGameOfTheDay] = useState(null);

	useEffect(() => {
	  function changeGameOfTheDay() {
		const randomGame = games[Math.floor(Math.random() * games.length)];
		localStorage.setItem('gameOfTheDay', JSON.stringify(randomGame));
		localStorage.setItem('gameOfTheDayTimestamp', Date.now());
		setGameOfTheDay(randomGame);
	  }
  
	  const storedGame = JSON.parse(localStorage.getItem('gameOfTheDay'));
	  const storedTimestamp = parseInt(localStorage.getItem('gameOfTheDayTimestamp'), 10);
	  const now = Date.now();
  
	  if (storedGame && storedTimestamp && (now - storedTimestamp) < 24 * 60 * 60 * 1000) {
		setGameOfTheDay(storedGame);
	  } else {
		changeGameOfTheDay();
	  }
  
	  const interval = setInterval(changeGameOfTheDay, 24 * 60 * 60 * 1000);
  
	  return () => clearInterval(interval);
	}, []);

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
	};
	
	const firstImages=<img src="assets/images/coins.webp" alt="" style={{height:'50px', width:'30px'}}/>
	const secondImage=<img src="assets/images/coins.webp" alt="" style={{height:'50px', width:'30px',marginLeft:'1px'}}/>
	const thirdImage=<img src="assets/images/coins.webp" alt="" style={{height:'50px', width:'30px',marginLeft:'1px'}}/>

	return (
		  <div className={`App ${loading ? 'loading' : ''}`}>
			{loading && <Spinner/>}
      <div style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
	{!loading &&(<div>
			
			<div>
			<div class="hero-area carousel-background">
				<div class="carousel-container">
					<div class="row">
						<div class="col-lg-12">
							<div class="content">
								<div class="content">
									<h5 class="subtitle">
										PLAY NOW
									</h5>
									<h1 class="title">
										<img src="assets/images/text.webp" alt="Play and Win" className='play-heading' />
									</h1>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
			<section class="game-play-section" >
				<div class="container">
					<div class="row ">
						<div class="col-lg-12">
							<div class="section-heading" style={{ marginTop: '-40px'  }}>
								<h5 class="subtitle">
									The Games You Love
								</h5>
								<h2 class="title ">
									Adventure Begins
								</h2>
								<h6 class="text">
									Join millions of players in Pakistan.
								</h6>
							</div>
						</div>
					</div>
					<div  style={{display:'flex', flexDirection:'row', alignItems:'center',marginBottom: '50px',gap:'8px',width:'100%'}}>
						<ImageSlider/>
					</div>

				</div>

				{/* +========================================CETEGORIES===========================================================================					 */}
				<div class='main' 
					style={{ marginTop: '35px'  
					}}>
					<h1 class='CETEGORIES' style={{ fontSize: '1.5em' }}>CATEGORIES</h1>
					<div class='cetegory-box2 new-category-box'>

						{/* +++++++++++++++++++++++++++++++++++++++++Cetegory1++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++				 */}

						<div class='out-text'>
							<Link to="/action">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/action-1.webp" alt="action" className="zoomable-image" />
									</div>
								</div>
								<h6 class='C-heading'>ACTION</h6>
							</Link>
						</div>

						{/* 
+++++++++++++++++++++++++++++++++++++++++++++Cetegory2++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
						<div class='out-text'>
							<Link to="/sports">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/sports1.webp" alt="sports" className="zoomable-image" />
									</div>

								</div>
								<h6 class='C-heading'>SPORTS</h6>
							</Link>
						</div>
						{/* 							
+++++++++++++++++++++++++++++++++++++++++++++++Cetegory3++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++						 */}
						<div class='out-text'>
							<Link to="/adventure">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/Adventure1.webp" alt="adventure" className="zoomable-image" />
									</div>
								</div>
								<h6 class='C-heading'>ADVENTURE</h6>
							</Link>
						</div>
					
					{/* 							
++++++++++++++++++++++++++++++++++++++++++++Cetegory4++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++						 */}
					
						<div class='out-text'>
							<Link to="/racing">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/racing.webp" alt="racing" className="zoomable-image" />
									</div>

								</div>
								<h6 class='C-heading'>RACING</h6>
							</Link>
						</div>

						{/* +++++++++++++++++++++++++++++++++++++++++++++++Cetegory5++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++						 */}


						<div class='out-text'>
							<Link to="/strategy">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/Strategy.webp" alt="strategy" className="zoomable-image" />
									</div>

								</div>
								<h6 class='C-heading'>STRATEGY</h6>
							</Link>

						</div>

						{/* ++++++++++++++++++++++++++++++++++++++++++++Cetegory6+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}

						<div class='out-text'>
							<Link to="/puzzle">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/Puzzle.webp" alt="puzzel" className="zoomable-image" />
									</div>

								</div>
								<h6 class='C-heading'>PUZZLE</h6>
							</Link>

						</div>
					
					 

						{/* +++++++++++++++++++++++++++++++++++++++++Cetegory7++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++				 */}

						<div class='out-text'>
							<Link to="/casual">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/Casual.webp" alt="casual" className="zoomable-image" />
									</div>
								</div>
								<h6 class='C-heading'>CASUAL</h6>
							</Link>
						</div>
						{/* 
+++++++++++++++++++++++++++++++++++++++++++++Cetegory8++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
						<div class='out-text'>
							<Link to="/memory">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/Memory.webp" alt="memory" className="zoomable-image" />
									</div>
								</div>
								<h6 class='C-heading'>MEMORY</h6>
							</Link>
						</div>
						{/* 							
+++++++++++++++++++++++++++++++++++++++++++++++Cetegory9++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++						 */}
						<div class='out-text'>
							<Link to="/twoplayer">
								<div class="single-play17">
									<div class="image">
										<img src="assets/images/2-player.webp" alt="two-player" className="zoomable-image" />
									</div>
								</div>
								<h6 class='C-heading'>2 PLAYER</h6>
							</Link>
						</div>
					
					{/* 							
++++++++++++++++++++++++++++++++++++++++++++Cetegory10++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++						 */}
				</div>
				</div>
				{/* +++++++++++++++++++++++++++++++++++++++++++++Cetegry div end+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}

				<div class="row" style={{ marginTop: '-40px', marginBottom:'70px'  }}>
					<div class="col-lg-12 text-center">
						<Link to="/games-all" class="b-all-btn">Browse All Games <img src="assets/images/arrow.webp" alt="browse-all" /></Link>
					</div>
				</div>
							<div className='game-of-day-full-div'>
								<h1 className='CATEGORIES' style={{ fontSize: '1.5em', textahmedgn: 'center', marginBottom: '3%', textAlign: 'center' }}>GAME OF THE DAY</h1>
								{gameOfTheDay && (
									<div className="single-play17 game-of-day" style={{ marginLeft: '10%', marginRight: '10%' }}>
										<div className="image" style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
											<img src={`assets/Icons/${gameOfTheDay.thumbnail}`} alt="" className="zoomable-image" />
											<div style={{marginBottom:'10px'}}>
											<img src="assets/images/star.png" alt="star" height={20} width={20} style={{marginRight:'4px'}}/>
                                            <img src="assets/images/star.png" alt="star" height={20} width={20} style={{marginRight:'4px'}}/>
                                            <img src="assets/images/star.png" alt="star" height={20} width={20} style={{marginRight:'4px'}}/>
                                            <img src="assets/images/star.png" alt="star" height={20} width={20} style={{marginRight:'4px'}}/>
                                            <img src="assets/images/star.png" alt="star" height={20} width={20} />
											</div>
											<a href="" className='like-button game-of-day-play' style={{ textAlign:'center'}} onClick={() => handleClick(`assets/Icons/${gameOfTheDay.thumbnail}`, gameOfTheDay.url)}>Play</a>
										</div>
									</div>
								)}
							</div>
			</section>
			<FullScreenGames/>
			<section className='download-games-categories'>

			<section className="game-play-section download-game-play-section" style={{   }}> 
            <h1 class='CETEGORIES' style={{ fontSize: '1.5em',marginBottom:'18px' }}>DOWNLOADABLE GAMES</h1>               
            <div className="games-container" style={{ display: 'flex', flexWrap: 'wrap' , justifyContent:'center' ,gap:'16px',marginBottom:'15px'}}>
            {actionGames.map((game, index) => (
                        <div key={index} className="single-play1 download-game-box " style={{ marginBottom: '20px' }}>
                            <div className="image" style={{ width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'10px'}}>
                                <img src={`assets/Icons/${game.thumbnail}`} alt="games-images" className="zoomable-image download-game-image"  loading="lazy"  /> 
                                </div>
                            <div className='download-like-div' style={{  display: 'flex', alignItems: 'end' , position:'relative',marginTop:'10px', width:'100%'}}>              
                                    <a className='download-button' style={{ display:'flex', fontSize:'16px',width:'100%',justifyContent:'center'}} href={`https://cdn-content.mmsdp.com/newgames-may-2/Downloadable%20Games/Action/${game.url}`}
                                        // onClick={() => handleClick(`assets/Icons/${game.thumbnail}`, game.url)}
                                    >
                                        Download
                                    </a>    
                                    
                            </div>
                        </div>
                    ))}
                </div>              
				<div class="col-lg-12 text-center">
						<Link to="/downloadnow" style={{color:'#cfcffd'}}>Browse All Download Games <img src="assets/images/arrow.webp" alt="browse-all" /></Link>
					</div>
            </section>

			</section>
			<section className="latest-arcive">
				<div className="container">
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<div className="col-lg-6">
							<div className="sh-wrpper" style={{justifyContent:'center' , display: 'flex' , margin:'0px',gap:'4px'}}>
								<img style={{margin:'0px'}} src="assets/images/arcive/i1.webp" alt="" />
								<div className="section-heading">
									<h2 className="title" style={{fontSize:'36px'}}>Leaderboard</h2>
								</div>
							</div>
							<Slider {...settings}>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Brick-Breaker-Unicorn</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Imran</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>7325 Coins</h6>
											{/* <img src="assets/images/coins2.webp" alt="" /> */}
											<div style={{display:'flex'}}>
												{firstImages} {secondImage}{thirdImage}
											</div>
										</div>
									</div>
									<div className="s-a-b" >
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Alwi</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>5745 Coins</h6>
											{/* <img src="assets/images/coins2.webp" alt="" /> */}
											<div style={{display:'flex'}}>
												{secondImage}{thirdImage}
											</div>
										</div>
									</div>
									<div className="s-a-b" >
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Omair</h6>
										</div>
										<div className="right" style={{marginLeft:'15px',marginTop:'30px'}}>
											<h6>2130 Coins</h6>
											{/* <img src="assets/images/coins2.webp" alt="" /> */}
											<div style={{display:'flex'}}>
												{thirdImage}
											</div>
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Halloween Bubble Shooter</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Nishat</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>4765 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Sajjad</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>3512 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b" >
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Altaf</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1208 Coins</h6>
											{firstImages}
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Handless Millionaire</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Adil</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>9427 Coins</h6>
											<div style={{display:'flex'}}>
												{firstImages} {secondImage}{thirdImage}
											</div>
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Rukhsar</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>6374 Coins</h6>
											<div style={{display:'flex'}}>
												{firstImages} {secondImage}
											</div>
										</div>
									</div>
									<div className="s-a-b" >
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Junaid</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>5392 Coins</h6>
											<div style={{display:'flex'}}>
												{firstImages}
											</div>
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Pops-Billiards</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Jahanzeb</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>4085 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Jamil</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>2629 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Laiba</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1848 Coins</h6>
											{firstImages}
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Pro-Billiards</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Khalil</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>5429 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Sohail</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>4637 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Suleman</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1913 Coins</h6>
											{firstImages}
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Professor-Bubble</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Rohail</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>4593 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Tahir</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>2416 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Kashif</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1907 Coins</h6>
											{firstImages} 
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Jetpack-Heroes</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Rizwan</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>5413 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Hussain</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>2326 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Raheel</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1374 Coins</h6>
											{firstImages}
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Mad-Fish</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Haris</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>5058 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Qasim</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>2973 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Rayyan</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1347 Coins</h6>
											{firstImages} 
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Road-Racer</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Dilawar</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>7985 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Asad</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>6454 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Anjum</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>4485 Coins</h6>
											{firstImages}
										</div>
									</div>
								</div>
								<div className="l-arcive-box">
									<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Robotex</h5>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position1.webp" alt="" />
											<h6>Ali</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>2473 Coins</h6>
											{firstImages} {secondImage}{thirdImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 2.webp" alt="" />
											<h6>Atif</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1566 Coins</h6>
											{firstImages} {secondImage}
										</div>
									</div>
									<div className="s-a-b">
										<div className="left">
											<img src="assets/images/position 3.webp" alt="" />
											<h6>Raees</h6>
										</div>
										<div className="right" style={{marginTop:'30px'}}>
											<h6>1283 Coins</h6>
											{firstImages} 
										</div>
									</div>
								</div>
												<div className="l-arcive-box">
													<h5 className="subtitle" style={{ justifyContent: 'center', display: 'flex' }}>Stick
														Monkey</h5>
													<div className="s-a-b">
														<div className="left">
															<img src="assets/images/position1.webp" alt="" />
															<h6>Raza</h6>
														</div>
														<div className="right" style={{marginTop:'30px'}}>
															<h6>5498 Coins</h6>
															{firstImages} {secondImage}{thirdImage}
														</div>
													</div>
													<div className="s-a-b">
														<div className="left">
															<img src="assets/images/position 2.webp" alt="" />
															<h6>Sufyan</h6>
														</div>

														<div className="right" style={{marginTop:'30px'}}>
															<h6>2074 Coins</h6>
															{firstImages} {secondImage}
														</div>
													</div>
													<div className="s-a-b">
														<div className="left">
															<img src="assets/images/position 3.webp" alt="" />
															<h6>Hassan</h6>
														</div>
														<div className="right" style={{marginTop:'30px'}}>
															<h6>1453 Coins</h6>
															{firstImages} 
														</div>
													</div>
												</div>
							</Slider>
						</div>
					</div>
				</div>
			</section>
		</div>)}
		</div>
    </div>
	);
};

export default MerakiHomeBody;